<template>
  <div class="showCard" ref="showCard">
    <ul class="infinite-list" style="overflow: auto">
      <li v-for="item in listInfo" :key="item.id" class="infinite-list-item">
        <div class="listTable" @click="infopanshow(item)">
          
          <!-- 信息显示 -->
          <div class="left">
            <div class="name">
              {{ item.pdescribe }}
              <small style="float: right"> {{ item.name }}</small>
            </div>
            <div class="address">
              <svg-icon icon-class="place" class="MapArrorSvg"></svg-icon>
              <small
                style="text-decoration: underline; cursor: pointer"
                @click="mapjump(item)"
              >
                {{ item.pdetail }}</small
              >
            </div>
            <div class="time">
              <svg-icon icon-class="time" class="MapArrorSvg"></svg-icon>
              <small>{{ item.openingText?item.openingText.split("&#")[0]:"" }}</small>
            </div>
            <div class="prompt">
              <div><svg-icon icon-class="prompt" class="MapArrorSvg"></svg-icon></div>
              <div><small>{{ item.openingText?item.openingText.split("&#")[1]:"" }}</small></div>
            </div>
          </div>
          <!-- 图片显示 -->
          <div class="right">
            <div class="img">
              <div v-if="item.online">
                <div v-for="item2 in item.overflows" :key="item.mid">
                  <img
                    v-if="item2.rid == RecycleTypevalue"
                    :src="item2.image"
                    alt="图片"
                    style="height: 80px"
                  />
                </div>
              </div>
              <div v-else>
                <img :src="item.image" alt="" style="height: 80px" />
              </div>
            </div>
            <div class="tips">
              <div v-if="item.online && item.error !== 1">
                <div v-for="item3 in item.overflows" :key="item.rid">
                  <small v-if="item3.rid == RecycleTypevalue">
                    <div v-if="item3.overflow >= '90'">溢满</div>
                    <div v-else>
                      {{ item3.imageC }}
                    </div></small
                  >
                </div>
              </div>
              <div v-else>
                <small>{{ item.imageC }}</small>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { jumpGoogle } from "@/utils/mapjump.js";
import { EventBus } from "./MEventBus.js";
export default {
  props: [
    "listInfo",
    "RecycleTypevalue",
    "activeList",
    // "minVal",
    // "index",
    // "length",
  ],
  data() {
    return {};
  },
  mounted() {
    console.log(this.listInfo);
    this.changeShwoRadius(this.activeList);
  },
  methods: {
    // 添加显示样式
    changeShwoRadius(val) {
      console.log(val, "val");
      this.$refs.showCard.classList = [];
      this.$refs.showCard.classList.add("showCard");
      if (val == 1) {
        this.$refs.showCard.classList.add("leftRadius");
      } else if (val == 9 || val == 5) {
        // - this.minVal == 9 || this.index == this.length - 1
        this.$refs.showCard.classList.add("rightRadius");
      } else {
        this.$refs.showCard.classList.add("Radius");
      }
    },
    // 谷歌地图跳转
    mapjump(val) {
      if (val.platLng) {
        jumpGoogle(val);
      } else {
        this.$message("暂无信息");
      }
    },
    // 信息面板显示
    infopanshow(val) {
      console.log(val, "val");
      if (val.platLng) {
        EventBus.$emit("infopane", val);
      } else {
        this.$message("暂无信息");
      }
    },
  },
  watch: {
    activeList: {
      handler: function (newValue, oldValue) {
        this.changeShwoRadius(newValue);
      },
    },
  },
};
</script>

<style scoped>
/* 样式修改 */
.leftRadius {
  border-radius: 15px;
  border-top-left-radius: 0;
}
.rightRadius {
  border-radius: 15px;
  border-top-right-radius: 0;
}
.Radius {
  border-radius: 15px;
}
.listTable {
  margin: 0;
  padding: 0;
  /* height: 110px; */
  display: flex;
  flex-direction: row;
  padding: 10px;
  gap: 10px;
  /* margin-left: 14px;
  text-align: left;
  box-sizing: border-box; */
}
.listTable .left {
  flex: 8;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
/* .listTable .left .name {
  flex: 1;
} */
/* .listTable .left .address {
  flex: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  font-size: 15px;
} */
.name,
.time,
.prompt,
.address {
  /* flex: 1; */
  display: flex;
  /* flex-direction: row; */
  align-items: flex-start;
  gap: 5px;
  font-size: 15px;
  flex-wrap: nowrap;
}
.name {
  align-items: center;
}
.listTable .right {
  flex: 3;
  display: flex;
  flex-direction: column;
  align-content: flex-end;
}
.listTable .right .img {
  flex: 1;
  text-align: center;
}
.listTable .right .tips {
  flex: 5;
  text-align: center;
  font-size: 15px;
}
.infinite-list {
  list-style: none;
  /* position: relative; */
  height: 95%;
  padding-bottom: 20px;
  overflow: hidden;
}
.infinite-list-item {
  background-color: #fff;
  width: 95%;
  margin: 10px 0;
  border-radius: 15px;
  padding: 10px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
  height: 160px;
}
.showCard {
  background-color: rgba(245, 249, 250, 0.83);
  position: absolute;
  width: 100%;
  height: 100%;
  margin-top: 1px;
  padding-right: 10px;
  padding-bottom: 10px;
  overflow: hidden;
}
::-webkit-scrollbar {
  width: 18px;
  margin-right: 500px;
}
::-webkit-scrollbar-track {
  width: 18px;
  background-color: rgba(236, 236, 236, 0.2);
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}

::-webkit-scrollbar-thumb {
  width: 10px;
  /* box-shadow: inset 0 0 6px blue;
  -webkit-box-shadow: inset 0 0 6px pink; */
  background-color: #c4c4c4;
  background-clip: padding-box;
  border-radius: 15px;
}

/* 


::-webkit-scrollbar-thumb {
  width: 8px;
  box-shadow: inset 0 0 6px blue;
  -webkit-box-shadow: inset 0 0 6px pink;
  background-color: yellow;
  background-clip: padding-box;
  border-radius: 5px;
}

 */
</style>
